import { render, staticRenderFns } from "./TradeInfo.vue?vue&type=template&id=42948834&"
import script from "./TradeInfo.vue?vue&type=script&lang=js&"
export * from "./TradeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports